import React from 'react';
import { IconButton, IconButtonProps } from '../iconButton';
import Apps from '../icons/Apps';
import {
  Dropdown,
  DropdownAnchor,
  DropdownItem,
  useDropdownControls,
} from './Dropdown';

interface AppItem {
  name: string;
  url: string;
  target?: React.HTMLAttributeAnchorTarget;
}

export interface AppsListProps extends AppsButtonProps {
  apps: AppItem[];
}

interface AppsButtonProps
  extends Omit<
    IconButtonProps,
    'size' | 'children' | 'aria-label' | 'color' | 'variant'
  > {}

export const AppsButton = ({ ...props }: AppsButtonProps) => (
  <IconButton size="large" variant="text" aria-label="apps" {...props}>
    <Apps />
  </IconButton>
);

function AppsList({ apps, ...props }: AppsListProps) {
  const [anchorEl, handleOpen, handleClose] = useDropdownControls(
    props.onClick,
  );

  return (
    <>
      <AppsButton
        {...props}
        selected={Boolean(anchorEl)}
        onClick={handleOpen}
      />

      <Dropdown
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {apps.map((app) => (
          <DropdownItem key={app.name}>
            <DropdownAnchor
              href={app.url}
              target={app.target ? app.target : '_blank'}
            >
              {app.name}
            </DropdownAnchor>
          </DropdownItem>
        ))}
      </Dropdown>
    </>
  );
}

export default React.memo(AppsList);
